import { Button } from 'mmfintech-portal-commons'
import { ErrorIcon } from './ErrorIcon'

import './errorFallback.scss'

type ErrorFallbackProps = {
  resetErrorBoundary?: () => void
}

const ErrorFallback = ({ resetErrorBoundary }: ErrorFallbackProps) => (
  <div className='error-fallback-wrapper'>
    <div className='error-fallback-content'>
      <ErrorIcon />

      <p>An unexpected error occurred</p>

      {resetErrorBoundary ? (
        <Button color='alternative' onClick={resetErrorBoundary} text='Go back to the home page' />
      ) : null}
    </div>
  </div>
)

export default ErrorFallback
